module.exports = __webpack_public_path__ + "images/embed/icons/facebook_icon_dark.png";